
export const setSelectedCoin = (coinId) => (dispatch, getState) => {
  dispatch({type: 'SET_SELECTED_COIN', payload: coinId})
  dispatch({ type: 'remove_counts' })
  dispatch({ type: 'remove_redditMentions' })
  dispatch({ type: 'remove_redditMentionsSub' })
  dispatch({ type: 'remove_currentCount' })
  dispatch({ type: 'remove_priceData' })
}

export const setTrackedDays = (days) => (dispatch, getState) => {
  dispatch({ type: 'SET_TRACKED_DAYS', payload: days })
  dispatch({ type: 'remove_counts' })
  dispatch({ type: 'remove_redditMentions' })
  dispatch({ type: 'remove_redditMentionsSub' })
  dispatch({ type: 'remove_currentCount' })
  dispatch({ type: 'remove_priceData' })
}



// WEBPACK FOOTER //
// ./src/actions/ui/index.js